export default [
	{
		id: 1,
		title: 'Pop',
		cover: 'https://i.scdn.co/image/567158eb895ad26718a814345af0fc43ee785ec5',
		color: '#8d67ab'
	},
	{
		id: 2,
		title: 'Dance / Electronic',
		cover: 'https://t.scdn.co/images/ea364e99656e46a096ea1df50f581efe',
		color: '#dc148c'
	},
	{
		id: 3,
		title: 'Hiphop',
		cover: 'https://charts-images.scdn.co/assets/locale_en/regional/weekly/region_global_default.jpg',
		color: '#ba5d07'
	},
	{
		id: 4,
		title: 'Rock',
		cover: 'https://i.scdn.co/image/ab67706f000000027ea4d505212b9de1f72c5112',
		color: '#e61e32'
	},
	{
		id: 5,
		title: 'Discover',
		cover: 'https://t.scdn.co/images/d0fb2ab104dc4846bdc56d72b0b0d785.jpeg',
		color: '#ba5d08'
	}
]